import FlavorSummaryAttributeIntensity from './FlavorSummaryAttributeIntensity';
export default FlavorSummaryAttributeIntensity;
